<h2 mat-dialog-title class="text-center">
  <span class="text-white">{{ isNew ? 'Nueva liquidación' : 'Editar liquidación' }}</span>
  <button mat-icon-button type="button" aria-label="Cerrar" class="dialog-close top-0 right-0" (click)="dialogRef.close(false)">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-2">

    <div class="flex gap-4">
      <mat-form-field appearance="fill" floatLabel="always" class="flex-1">
        <mat-label>Semana</mat-label>
        <input matInput type="number" formControlName="week" min="1" max="60" placeholder="1–60">
        <mat-error *ngIf="form.get('week')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('week')?.hasError('min') || form.get('week')?.hasError('max')">Debe estar entre 1 y 60</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" floatLabel="always" class="flex-1">
        <mat-label>Año</mat-label>
        <input matInput type="number" formControlName="year" min="2000" placeholder="ej. 2025">
        <mat-error *ngIf="form.get('year')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('year')?.hasError('min')">Año inválido</mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" floatLabel="always" class="w-full">
      <mat-label>Días de descuento</mat-label>
      <input matInput type="number" formControlName="daysOfWeek" min="1" placeholder="ej. 7">
      <mat-hint>Días a aplicar para descuentos por día (independiente del rango de fechas)</mat-hint>
      <mat-error *ngIf="form.get('daysOfWeek')?.hasError('required')">Requerido</mat-error>
      <mat-error *ngIf="form.get('daysOfWeek')?.hasError('min')">Debe ser al menos 1</mat-error>
    </mat-form-field>

    <div class="flex flex-col gap-1">
      <span class="text-sm text-gray-400">Archivo Excel</span>

      <label [class.opacity-50]="isUploading || isProcessing">
        <input type="file" accept=".xlsx,.xls" class="hidden" (change)="onFileSelected($event)" [disabled]="isUploading || isProcessing">
        <span class="inline-flex items-center gap-1 text-sm border border-gray-600 rounded px-3 py-1 text-gray-300 hover:border-gray-400 cursor-pointer">
          <mat-icon class="text-base leading-none">upload_file</mat-icon>
          Seleccionar archivo
        </span>
      </label>

      <div *ngIf="currentExcelName" class="flex items-center gap-1 text-xs text-gray-400 mt-1">
        <mat-icon class="text-green-400 leading-none" style="font-size:14px;width:14px;height:14px;">check_circle</mat-icon>
        <span>{{ currentExcelName }}</span>
      </div>

      <span *ngIf="showExcelError && !excelReady" class="text-red-400 text-xs mt-1">El archivo Excel es requerido</span>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" type="button" (click)="onProcess()" [disabled]="isUploading || isProcessing">
    {{ isProcessing ? 'Procesando...' : 'Procesar' }}
  </button>
</mat-dialog-actions>
